import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';
import { Subscription, map } from 'rxjs';

import { ProductDetailedResponse } from '@app/api/models';
import { environment } from '@environments/environment';
import {
  ProductSearchActions,
  ProductSearchSelectors,
} from '@search/store/search.slice';
import { SwiperImage } from '@shared/components/image-swiper/image-swiper.component';

@Component({
  selector: 'app-product-details-container',
  templateUrl: './product-details-container.component.html',
  styleUrls: ['./product-details-container.component.scss'],
})
export class ProductDetailsContainerComponent implements OnInit, OnDestroy {
  readonly imageBaseUrl = `${environment.imageStorageUrl}`;
  activeIndex = 0;

  product$ = this.store.select(ProductSearchSelectors.selectActiveProduct);
  logoImages$ = this.product$.pipe(
    map((product) =>
      product?.suppliers?.map(
        (supplier) =>
          ({
            url:
              this.imageBaseUrl + '/merchants/' + supplier.merchantId + '/logo',
            alt: supplier.name,
          } as SwiperImage)
      )
    )
  );

  subs = new Subscription();

  constructor(private route: ActivatedRoute, private store: Store) {}

  ngOnInit(): void {
    this.subs.add(
      this.route.params.subscribe((params) => {
        if (params['id']) {
          this.store.dispatch(
            ProductSearchActions.getActiveProduct.trigger({
              packagingUnitId: params['id'],
            })
          );
        }
      })
    );
  }

  productProp(product: ProductDetailedResponse, prop: string) {
    return product[prop as keyof ProductDetailedResponse];
  }

  prevImage(length: number) {
    this.activeIndex = this.activeIndex > 0 ? this.activeIndex - 1 : length - 1;
  }

  nextImage(length: number) {
    this.activeIndex = (this.activeIndex + 1) % length;
  }

  onCancel() {
    history.back();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
